import * as React from "react";
import { generate } from "shortid";

import { Copyright } from "../components/copyright";

export interface FooterData {
    footer: FooterType;
}

interface FooterType {
    items: FooterNavigationItem[];
}

export interface FooterNavigationItem {
    mainpage?: FooterNavigationLink;
    pages: FooterNavigationLink[];
}

export interface FooterNavigationLink {
    title: string;
    slug: string;
    icon?: string;
}

export const Footer = () => {
    const key = generate();

    interface AddressProps {
        title: string;
        subtitle?: string;
        contacts?: { num?: string; email?: string }[];
        address?: string[];
        openingTimes?: string;
        map?: string;
    }

    const AddressBody = ({
        title,
        subtitle,
        contacts,
        address,
        openingTimes,
        map,
    }: AddressProps) => (
        <>
            <p className="footer-place-text">{title}</p>

            {subtitle && <p className="footer-place-text">{subtitle}</p>}

            {contacts && (
                <div className="footer-numbers" key={key}>
                    {contacts.map(({ num, email }) => (
                        <p className="footer-text" key={generate()}>
                            {num && (
                                <a className="footer-phone" href={`tel:${num}`}>
                                    <i className="fas fa-phone footer-icon-inflate footer-icon-contact" />
                                    {num}
                                </a>
                            )}
                            {email && (
                                <a
                                    className="footer-email"
                                    href={`mailto:${email}?subject=Inquiries from Ngāti Kuia website`}
                                    target="_blank"
                                    rel="noreferrer"
                                    aria-label="email-link">
                                    <i className="fas fa-envelope footer-icon-inflate footer-icon-contact" />
                                    {email}
                                </a>
                            )}
                        </p>
                    ))}
                </div>
            )}
            {address && (
                <div>
                    <a
                        className="footer-text footer-address-container"
                        href={map}
                        target="_blank"
                        rel="noreferrer"
                        aria-label="address_link">
                        {map && (
                            <i className="fas fa-map footer-icon-inflate footer-icon-contact" />
                        )}
                        <div className="footer-address">
                            {address.map((line) => (
                                <div key={generate()}>{line}</div>
                            ))}
                        </div>
                    </a>
                </div>
            )}
            {openingTimes && <p className="footer-text">{openingTimes}</p>}
        </>
    );

    const Address = ({
        title,
        subtitle,
        contacts,
        address,
        openingTimes,
        map,
    }: AddressProps) => (
        <div className="footer-sections">
            <address className="footer-address" key={key}>
                <AddressBody
                    title={title}
                    subtitle={subtitle}
                    contacts={contacts}
                    address={address}
                    openingTimes={openingTimes}
                    map={map}
                />
            </address>
        </div>
    );

    const socialIcons = () => (
        <>
            <div>
                <p className="footer-navigation-title">Connect With Us</p>

                <div className="footer-social">
                    {process.env.NGATI_KUIA_FACEBOOK && (
                        <a
                            href={process.env.NGATI_KUIA_FACEBOOK}
                            target="_blank"
                            rel="noreferrer"
                            aria-label="facebook_icon_link">
                            <i className="fab fa-facebook-square footer-facebook footer-icon-inflate" />
                        </a>
                    )}
                    {process.env.NGATI_KUIA_FACEBOOK && (
                        <a
                            href={process.env.NGATI_KUIA_FACEBOOK}
                            className="footer-links"
                            target="_blank"
                            rel="noreferrer">
                            Facebook
                        </a>
                    )}
                </div>
                <div className="footer-social">
                    {process.env.NGATI_KUIA_YOUTUBE && (
                        <a
                            href={process.env.NGATI_KUIA_YOUTUBE}
                            target="_blank"
                            rel="noreferrer"
                            aria-label="youtube_icon_link">
                            <i className="fab fa-youtube-square footer-youtube footer-icon-inflate" />
                        </a>
                    )}
                    {process.env.NGATI_KUIA_YOUTUBE && (
                        <a
                            href={process.env.NGATI_KUIA_YOUTUBE}
                            className="footer-links"
                            target="_blank"
                            rel="noreferrer">
                            YouTube
                        </a>
                    )}
                </div>
                <div>
                    {process.env.NGATI_KUIA_INSTAGRAM && (
                        <a
                            href={process.env.NGATI_KUIA_INSTAGRAM}
                            target="_blank"
                            rel="noreferrer"
                            aria-label="insta_icon_link">
                            <i className="fab fa-instagram-square footer-instagram footer-icon-inflate" />
                        </a>
                    )}
                    {process.env.NGATI_KUIA_INSTAGRAM && (
                        <a
                            href={process.env.NGATI_KUIA_INSTAGRAM}
                            className="footer-links"
                            target="_blank"
                            rel="noreferrer">
                            Instagram
                        </a>
                    )}
                </div>
            </div>
        </>
    );


    return (
        <div className="footer">
            <div className="footer-layer secondary">
                <div className="footer-inner || constrain-width">
                    <div className="footer-sections">
                        <div className="footer-logo" />
                    </div>
                    <Address
                        title="Contact Us"
                        contacts={[
                            { num: "0800 NGATI KUIA" },
                            { num: "0800 642 845" },
                            { num: "03 546 7556" },
                            { email: "tari@ngatikuia.iwi.nz" },
                        ]}
                        openingTimes="Mon - Fri, 8.30am - 5pm"
                        address={[
                            "192 Rutherford Street",
                            "PO Box 968",
                            "Nelson 7040",
                        ]}
                        map="https://www.google.com/maps/place/Te+Runanga+O+Ngati+Kuia/@-41.2778812,173.2804265,15z/data=!4m5!3m4!1s0x0:0x9e8f313945c1e14!8m2!3d-41.2779375!4d173.2804269"
                    />
                    <div className="footer-sections">
                        <div className="footer-section">{socialIcons()}
                        </div>
                    </div>
                </div>
            </div>
            <footer className="footer-layer divider">
                <div className="footer-inner logo || constrain-width">
                    <Copyright />
                </div>
            </footer>
        </div>
    );
};
